import type { FaireProductEntity } from "../../entity_types/product";

export const p_y6ytes9bmv: FaireProductEntity = {
  token: "p_y6ytes9bmv",
  type: "product",
  name: "4\"H 2 Piece Yunomi Tea Cups Gift Set Dragonfly Design (1/16)",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/ee5184c91580e7a935fa76b96670cd0158f36ddc943cb19765be9a7c4c9628da.png",
  galleryImageUrls: [],
  priceDollars: 7,
  description: "Size: 3.3\"D x 4\"H Capacity: 10 fl oz\n\n2 Piece Set Packaging\n\nCase Pack: 16\n\nProduct Origin: China\n",
  tags: [],
  msrpDollars: 15.75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:49.604Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
